import { Box } from '@mui/material';
import { ReactNode, useState } from 'react';
import { PeekColumn, PeekToolsSlot } from './entity-peek.elements';

// Mobile peek: the panel is a bare card column, so the host owns the scroller and
// the sticky tools slot (mirrors the mobile branch of SiteView/site-expanded.tsx).
export const EntityMobilePeek = ({
  children,
}: {
  children: (toolsSlot: HTMLElement | null) => ReactNode;
}) => {
  const [toolsSlot, setToolsSlot] = useState<HTMLElement | null>(null);

  return (
    <PeekColumn>
      {/* mobile keeps the wider card inset, so the slot keeps the matching offset too */}
      <PeekToolsSlot ref={setToolsSlot} sx={{ top: '0.5rem', paddingRight: '1.125rem' }} />
      <Box sx={{ pt: '0.5rem', px: '0.5rem', pb: '0.5rem' }}>{children(toolsSlot)}</Box>
    </PeekColumn>
  );
};
